import { render, staticRenderFns } from "./Targets.vue?vue&type=template&id=2099baa2&scoped=true&"
import script from "./Targets.vue?vue&type=script&lang=js&"
export * from "./Targets.vue?vue&type=script&lang=js&"
import style0 from "./Targets.vue?vue&type=style&index=0&id=2099baa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2099baa2",
  null
  
)

export default component.exports